/**
 * 라이더공지사항 등록 폼데이터
 */
export class FormDataStoreWorkProcess {
    /** 글 아이디 */
    id = '';
    /** 제목 */
    title = '';
    /** 내용 */
    body = '';
    /** 부모 글 */
    parentBody = '';
    /** 작성자 허브 name */
    createdByHubName = '';
    /** 작성자 name */
    createdByName = '';
    /** 선택한 허브 아이디 */
    selectedHubId = '';
    /** 소속 상점 전체 OR 상점 선택 여부 */
    targetType = 'ALL';
    /** 선택한 상점 */
    selectedStoreList = [];
    /** 중요글 여부 */
    isImportant = false;
    /** 답변글 여부 */
    isReply = false;
    /** 총판인지 판단. 허브 유저의 경우 hubId를 보내지 않아야 한다. */
    isHead = false;
    constructor(data) {
        if (!data) {
            return;
        }
        // get set 없이 딱 필드만 있게 하기 위해 중간에 처리
        const cls = new FormDataStoreWorkProcess();
        Object.getOwnPropertyNames(cls).forEach((it) => {
            const value = data[it];
            this[it] = value;
        });
    }
}
